module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/feedback-8450e3ee006352b979fea58ae4622c03.svg";